module.exports = __webpack_public_path__ + "img/web_02_1.05546732.png";